import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// import React, { Component, useState } from "react";
// import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import logo from "../../assets/images/logo.svg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  useEffect, useState
} from "react";
import AdminServices from '../services/externalServices/adminServices';
import CruzeLogo from "../../assets/images/logo/Cruze_Black.png"
import CircularProgress from '@mui/material/CircularProgress';

function Copyright(props) {


  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignIn() {
  // const [firstname, setFirstname] = useState("");
  const [emailID, setEmailID] = useState("");
  const [password, setPassword] = useState("");
  const [isUser, setIsUser] = useState(true);
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  // const handleUser = (event) => {
  //   if (event.target.name === 'firstname') {
  //     setFirstname(event.target.value);
  //   }
  //    if (event.target.name === 'password') {
  //     setPassword(event.target.value);
  //   }
  // };
  const data = { emailID, password }
  const validateUserLogin = async () => {
    setLoading(true);
    try {
      // const response = await axios.post("http://localhost:8080/login", {
      //   firstname,
      //   password,
      // });
      const response = await AdminServices.login(data);
      console.warn('reponse the Login %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%', response);

      if (response.token) {
        localStorage.setItem("token", response.token);
        localStorage.setItem('admin', JSON.stringify(response.adminFound));
        console.log("LoginSuccessFul");

        // ✅ Redirect based on the module
        // const module = response.adminFound.role || [];

        const role = response.adminFound.role;


        console.log('role of the user before entering this');

        if (role === "earnings-report-only") {
          navigate("/totalReport");
        } else if (role === "ticket-admin") {
          navigate("/tickets-dashboard");
        }
        else if (role === "tracking-admin") {
          console.log('inside the tracking');
          navigate("/tracking-dashboard");
        }
        else {
          navigate("/dashboard"); // fallback
        }


        // navigate("/dashboard");
        // fetchData();
      } else {
        console.log("inavlid");
        // setIsUser(false);
        alert("invalida username");
      }
    } catch (error) {
      // console.error('Error during login:', error);
      // alert('invalid username and password')
      setIsUser(false);
    } finally {
      setLoading(false);
    }

    //
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log({
      email: data.get('email'),
      password: data.get('password'),
    });
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs" sx={{ display: 'flex', alignItems: 'center' }}>
        <CssBaseline />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div className="brand-logo">
            <img
              // src="https://wmdservices.asia/img/logo.png"
              src={CruzeLogo}
              alt="logo"
              style={{ width: '250px', height: '102px' }}
            />
          </div>
          <Avatar sx={{ m: 1, bgcolor: 'black' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={(e) => {
                setEmailID(e.target.value)
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={(e) => {
                setPassword(e.target.value)
              }}
            />
            <div>
              {!isUser ? (
                <p className="text-danger">Enter Valid username and password</p>
              ) : (
                ''
              )}
            </div>
            {/* <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          /> */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, bgcolor: 'black', '&:hover': {
                bgcolor: 'black', // keeps the button black on hover
              }, }}
              onClick={validateUserLogin}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Sign In"} {/* Show loader */}
            </Button>
            {/* <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2" onClick={(event) => event.preventDefault()}>
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid> */}
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
